import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ApiError } from "../api/client";
import { SocialLoginButtons } from "./SocialLoginButtons";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loginWithCredentials } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await loginWithCredentials(email.trim(), password);
      navigate("/dashboard");
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
          ? err.message
          : "No se pudo iniciar sesión";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-grid" style={{ gap: "1.5rem" }}>
      <form className="form-grid" style={{ gap: "1rem" }} onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="empty-state" style={{ borderColor: "rgba(220, 38, 38, 0.4)", color: "#b91c1c" }}>
            {error}
          </div>
        )}
        <div className="form-grid">
          <label style={{ fontWeight: 600, color: "#334155" }}>
            Email
            <input
              className="input"
              type="email"
              placeholder="familia@gomez.es"
              value={email}
              onChange={event => setEmail(event.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <label style={{ fontWeight: 600, color: "#334155" }}>
            Contraseña
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={event => setPassword(event.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          <div style={{ marginTop: "-0.15rem" }}>
            <Link to="/auth/forgot-password" style={{ fontSize: "0.84rem", color: "#2563eb", fontWeight: 600 }}>
              ¿Has olvidado tu contraseña?
            </Link>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
          style={{ justifyContent: "center" }}
        >
          {isSubmitting ? "Accediendo..." : "Entrar"}
        </button>
      </form>
      <div>
        <p className="section-subtitle" style={{ marginBottom: "1rem" }}>
          O entra con Google:
        </p>
        <SocialLoginButtons />
      </div>
    </div>
  );
}
